import type { ComponentType, PropsWithChildren } from 'react';
import {
	Circle as RNCircle,
	type CircleProps,
	ClipPath as RNClipPath,
	type ClipPathProps,
	Defs as RNDefs,
	G as RNG,
	type GProps,
	Image as RNImage,
	type ImageProps,
	Line as RNLine,
	type LineProps,
	Path as RNPath,
	type PathProps,
	Pattern as RNPattern,
	type PatternProps,
	Polygon as RNPolygon,
	type PolygonProps,
	Polyline as RNPolyline,
	type PolylineProps,
	Rect as RNRect,
	type RectProps,
	Svg as RNSvg,
	type SvgProps as RNSvgProps,
	Use as RNUse,
	type UseProps,
} from 'react-native-svg';

// Our own type, not a straight re-export: this package owns every generated icon's prop type
// (`FC<SvgProps>`), so widening it here — rather than via an ambient `declare module` augmentation —
// gives every icon `className` typing everywhere it's imported, with no cross-workspace resolution
// ambiguity (see docs/codebase/packages/icons.md).
export type SvgProps = RNSvgProps & { className?: string };

// Cast through ComponentType so this package's JSX types don't nominally pin apps to one @types/react major (18 vs 19).
export const Circle = RNCircle as unknown as ComponentType<CircleProps>;
export const ClipPath = RNClipPath as unknown as ComponentType<ClipPathProps>;
export const Defs = RNDefs as unknown as ComponentType<PropsWithChildren>;
export const G = RNG as unknown as ComponentType<GProps>;
export const Image = RNImage as unknown as ComponentType<ImageProps>;
export const Line = RNLine as unknown as ComponentType<LineProps>;
export const Path = RNPath as unknown as ComponentType<PathProps>;
export const Pattern = RNPattern as unknown as ComponentType<PatternProps>;
export const Polygon = RNPolygon as unknown as ComponentType<PolygonProps>;
export const Polyline = RNPolyline as unknown as ComponentType<PolylineProps>;
export const Rect = RNRect as unknown as ComponentType<RectProps>;
export const Svg = RNSvg as unknown as ComponentType<SvgProps>;
export const Use = RNUse as unknown as ComponentType<UseProps>;

export type {
	CircleProps,
	ClipPathProps,
	GProps,
	ImageProps,
	LineProps,
	PathProps,
	PatternProps,
	PolygonProps,
	PolylineProps,
	RectProps,
	UseProps,
} from 'react-native-svg';
